import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, EffectFade } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-fade";
import { useState, useEffect } from "react";
import axios from "axios";

export default function SliderSection() {

    const [dataSlider, setDataSlider] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get("https://laravel-api.aj-mart.com/api/banners");
                const filteredData = response.data.banners.filter(slide => slide.banner_offer_image !== null);
                setDataSlider(filteredData);
            }
            catch (error) {
                console.error("Error When Fetch Brands : ", error);
            }
        }

        fetchData();
    }, []);

    return (
        <section className="relative py-12 bg-gray-50">
            <div className="container mx-auto px-4 max-w-6xl">
                <div className="relative rounded-xl overflow-hidden shadow-2xl">
                    <Swiper
                        modules={[ Autoplay, Pagination, EffectFade]}
                        spaceBetween={0}
                        slidesPerView={1}
                        effect="fade"
                        loop={true}
                        autoplay={{
                            delay: 3000,
                            disableOnInteraction: false,
                        }}
                        pagination={{
                            clickable: true,
                            dynamicBullets: true,
                            renderBullet: (index, className) => {
                                return `<span class="${className} bg-blue-600"></span>`;
                            },
                        }}
                        className="h-200 w-full h-[300px] aspect-[16/9]"
                    >
                        {dataSlider.map((slide) => (
                            <SwiperSlide key={slide.id}>
                                <div className="relative w-full h-full">
                                    <img
                                        src={`https://laravel-api.aj-mart.com/storage/app/public/${slide.banner_offer_image}`}
                                        alt=""
                                        className="op-fill w-full h-full object-cover"
                                    />
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div>
        </section>
    );
}
